import React, { useState, useCallback } from "react";
import { SpaceWrapper } from "../../components";
import { useSelector } from "react-redux";

const MyProfile = () => {
  const user = useSelector((state) => {
    const userData = state.user?.user;
    // Store user data in localStorage if it exists
    if (userData) {
      localStorage.setItem("userData", JSON.stringify(userData));
      return userData;
    }
    // Retrieve from localStorage if state is empty
    const storedUser = localStorage.getItem("userData");
    return storedUser ? JSON.parse(storedUser) : {};
  });
  const formatLongDate = useCallback((dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: undefined,
    });
  }, []);
  const [profileData] = useState({
    firstName: user?.name?.trim().split(" ").slice(0, -1).join(" ") || "N/A",
    lastName: user?.name?.trim().split(" ").slice(-1)[0] || "N/A",
    userId: user?.clientId || "N/A",
    email: user?.email || "N/A",

    joinDate: formatLongDate(user?.createdAt) || "N/A",
  });

  return (
    <SpaceWrapper>
      <div className="w-full flex-1 flex flex-col gap-4 p-4 pb-20 md:pb-4 relative max-w-[2000px]">
        <div className="max-w-[1200px] ">
          <div className="grid grid-cols-12 gap-8">
            {/* Right Column - Details */}
            <div className="col-span-8">
              <div className="bg-background_2/90 rounded-2xl shadow-sm p-8">
                <div className="border-b border-secondary/30 pb-6">
                  <h2 className="text-headline3 md:text-heading2 font-nunito font-bold text-secondary/90">
                    Profile Information
                  </h2>
                  <p className="mt-2 text-subtitle4 text-secondary/70">
                    Manage your profile information and settings
                  </p>
                </div>

                <div className="mt-8 space-y-6 ">
                  <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:grid-cols-2 md:gap-x-8 md:gap-y-6 ">
                    <div>
                      <label className="block text-subtitle2 text-secondary/90 mb-2 pl-2">
                        First Name
                      </label>
                      <div className="p-4 bg-secondary/5 border border-secondary/5 rounded-lg text-body2 text-secondary/80">
                        {profileData.firstName}
                      </div>
                    </div>
                    <div>
                      <label className="block text-subtitle2 text-secondary/90 mb-2 pl-2">
                        Last Name
                      </label>
                      <div className="p-4 bg-secondary/5 border border-secondary/5 rounded-lg  text-body2 text-secondary/80">
                        {profileData.lastName}
                      </div>
                    </div>
                    <div>
                      <label className="block text-subtitle2 text-secondary/90 mb-2 pl-2">
                        User ID
                      </label>
                      <div className="p-4 bg-secondary/5 border border-secondary/5 rounded-lg  text-body2 text-secondary/80 ">
                        {profileData.userId}
                      </div>
                    </div>
                    <div>
                      <label className="block text-subtitle2 text-secondary/90 mb-2 pl-2">
                        Email
                      </label>
                      <div className="p-4 bg-secondary/5 border border-secondary/5 rounded-lg  text-body2 text-secondary/80">
                        {profileData.email}
                      </div>
                    </div>
                  </div>

                  <div className="pt-6 ">
                    <h3 className="text-headline4 md:text-heading3 pl-1 font-nunito font-bold text-secondary/90">
                      Account Details
                    </h3>
                    <div className="bg-primary/50 p-4 rounded-xl border border-primary">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-secondary/55 font-medium">
                            Member Since
                          </p>
                          <p className="text-secondary/95 font-nunito font-semibold">
                            {profileData.joinDate}
                          </p>
                        </div>
                        <div className="h-12 w-12 bg-secondary/75 border border-secondary/20 rounded-full flex items-center justify-center">
                          <svg
                            className="w-6 h-6 text-background/90"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SpaceWrapper>
  );
};

export default MyProfile;
